import { gql } from '@apollo/client';
import { USER_NAME_FIELDS } from 'src/models/users/queries';

export const INTEGRATION_TOKEN_FIELDS = gql`
  fragment tokenFields on HashedIntegrationToken {
    hash
    name
    createdAt
    owner {
      ...userNameFields
    }
  }
  ${USER_NAME_FIELDS}
`;

export const GET_INTEGRATION_TOKENS = gql`
  query getIntegrationTokens {
    getIntegrationTokens {
      ...tokenFields
    }
  }
  ${INTEGRATION_TOKEN_FIELDS}
`;

export const CREATE_INTEGRATION_TOKEN = gql`
  mutation createIntegrationToken($name: String!) {
    createIntegrationToken(input: { name: $name }) {
      token
    }
  }
`;

export const REVOKE_INTEGRATION_TOKEN = gql`
  mutation revokeIntegrationToken($hash: String!) {
    revokeIntegrationToken(input: { hash: $hash }) {
      ...tokenFields
    }
  }
  ${INTEGRATION_TOKEN_FIELDS}
`;
